module.exports = __webpack_public_path__ + "media/images/preview_diary_2-aaff9a5b9f26cfd3f007f9eace34ecd7.webp";